package com.islamicmedia.site.pages.isitsafe

import androidx.compose.runtime.Composable
import com.islamicmedia.site.components.PublicReviewPage
import com.varabyte.kobweb.core.Page

/** Public SEO review — "/isitsafe/diary-of-a-wimpy-kid". Pulls the REAL cached analysis (baked in StaticReviews). */
@Page("/isitsafe/diary-of-a-wimpy-kid")
@Composable
fun DiaryOfAWimpyKidReviewPage() {
    PublicReviewPage(
        slug = "diary-of-a-wimpy-kid",
        blurb = "Is Diary of a Wimpy Kid OK for Muslim kids? Fitrah Filter checks movies, shows, games, and books against Islamic values. Here's the full breakdown for parents.",
    )
}
